import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Footer from "./Footer";
import Navbar from "./Navbar";

export default function PrivateRoute({ children }) {
  const isLoggedIn = useAuth();

  return isLoggedIn ? (
    <div>
      <Navbar />
      {children}
      <Footer />
    </div>
  ) : (
    <Navigate to="/" />
  );
}
